"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var localeManifest_js_1 = require("../localeManifest.js");
// The locale key should be lowercase to match the string generated by getSupportedFallbackForLocale,
// but the locale value is case-sensitive and should match the name of a locale directory
var FALLBACK_OVERRIDE = {
    'nb-no': 'no',
    'ne-ne': 'ne-NP',
    'quz-bo': 'quz-PE',
    'quz-ec': 'quz-PE',
    "zh-cn": "zh-Hans",
    "zh-hk": "zh-Hant",
    "zh-mo": "zh-Hant",
    "zh-sg": "zh-Hans",
    "zh-tw": "zh-Hant",
};
var DEFAULT_LOCALE = 'en';
var supportedLanguages = Object.keys(localeManifest_js_1.default);
function getSupportedFallbackForLocale(localeCode) {
    var localeParts = localeCode.toLowerCase().split('-');
    while (localeParts.length > 0) {
        var fallbackLocale = localeParts.join('-');
        var fallbackOverrideLocale = FALLBACK_OVERRIDE[fallbackLocale];
        if (fallbackOverrideLocale) {
            return getLocaleObjectForSupportedLocale(fallbackOverrideLocale);
        }
        for (var i = 0; i < supportedLanguages.length; i++) {
            // A match returns 0, so ! to return true for find (or false if they don't match)
            var currentSearchLocale = supportedLanguages[i];
            if (!currentSearchLocale.localeCompare(fallbackLocale, [], { sensitivity: 'base' })) {
                return getLocaleObjectForSupportedLocale(currentSearchLocale);
            }
        }
        localeParts.pop();
    }
    return getLocaleObjectForSupportedLocale(DEFAULT_LOCALE);
}
exports.default = getSupportedFallbackForLocale;
function getLocaleObjectForSupportedLocale(localeCode) {
    return __assign({ locale: localeCode }, localeManifest_js_1.default[localeCode]);
}
